import React from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom';
import './App.css'
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'
import Registration from './Pages/Registration/Registration'
import SignIn from './Pages/SignIn/SignIn'
import Tasks from './components/Tasks/Tasks'
import CodeEditor from './components/CodeEditor/CodeEditor'
import NotFoundPage from './components/NotFoundPage/NotFoundPage'
import * as Api from './Api/Api'
import {CurrentUserContext} from './contexts/CurrentUserContext'
import ErrorsPopap from './components/Popups/ErrorsPopup'

function App() {
  const [isLoggin, setIsLoggin] = React.useState(localStorage.getItem("token"))
  const [tasks, setTasks] = React.useState([])
  const [isSolvePartOpen, setIsSolvePartOpen] = React.useState(true)
  const [tests, setTests] = React.useState()
  const [errorMessage, setErrorMessage] = React.useState('')
  const [error, setError] = React.useState(false)
  const [isSanding, setIsSanding] = React.useState(false)
  const [isTestsCame, setIsTestsCame] = React.useState(false)
  const [taskNamber, setTaskNamber] = React.useState()
  const [currentUser, setCurrentUser] = React.useState({})
  const [errorTextForPopap, setErrorTextForPopap] = React.useState("Error")
  const [isErrorsPopupOpen, setIsErrorsPopupOpen] = React.useState(false)

  const navigate = useNavigate()

  React.useEffect(() => {
  const token = JSON.parse(localStorage.getItem("token"))
    if(token) {
    Api.getContent(token)
    .then((res) => {
      localStorage.setItem("tasks", JSON.stringify(res))
      setTasks(res)
      setIsLoggin(true)
    })
    .then(() => {
      Api.getUser(token)
        .then((res) => {
          setCurrentUser(res)
        })
      navigate('/tasks')    
      })
      .catch((err) => {
        console.log("Ошибка при получении контента:", err)
        navigate('/sign-in')
      })}/*else{
        navigate('/sign-in')
      }*/ 
  }, [])

  function handleRegSubmit(data) {
    Api.register({
      username: data.username,
      email: data.email,
      password: data.password,
    })
    .then((res) => {
      navigate('/sign-in');
    })
    .catch((err) => {
      const parsedError = JSON.parse(err);
        if (parsedError && parsedError.username && parsedError.username.length > 0) {
          const errorMessage = parsedError.username[0];
          setError(true);
          setErrorMessage(errorMessage);
        } else if (parsedError && parsedError.password && parsedError.password.length > 0) {
          const errorMessage = parsedError.password[0];
          setError(true);
          setErrorMessage(errorMessage);
        }
        setTimeout(() => {
          setError(false);
          setErrorMessage('');
        }, "3000");
    });
  }

function handleLoginSubmit(data) {
  Api.authorize({
    username: data.username,
    password: data.password,
  })
    .then((res) => {
      if (res) {
        localStorage.setItem("token", JSON.stringify(res.access));
        const token = res.access;
        Api.getContent(token)
          .then((res) => {
            Api.getUser(token)
              .then((res) => {
                setCurrentUser(res)
              })
            setTasks(res);
            setIsLoggin(true);
            navigate('/tasks');
            setError(false);
            setErrorMessage('');
            localStorage.setItem("tasks", JSON.stringify(res))
          })
          .catch((err) => {
            console.log("Ошибка при получении контента:", err);
          });
      } else {
        if (res.status === 401) {
          setError(true);
          setErrorMessage("Неправильное имя или пароль");
          setTimeout(() => {
            setError(false);
            setErrorMessage('');
          }, 3000)
        }
      }
    })
    .catch((err) => {
      setError(true);
      setErrorMessage("Неправильное имя или пароль");
      setTimeout(() => {
        setError(false);
        setErrorMessage('');
      }, 3000)
    });
}

function sendSolve(task, solution){
  setIsSanding(true)
  setIsTestsCame(false)
  Api.sendSolve({task, solution})
  .then((res) => {
    setIsSanding(false)
    setTests(res)
    setIsTestsCame(true)
    setIsSolvePartOpen(false)
    setTaskNamber(res.task)
  })
  .catch((err) => {
    setIsSanding(false)

      if (err === 500) {
        setIsErrorsPopupOpen(true);
        setErrorTextForPopap('Ошибка соединения с сервером 1С');
      } else {
        const parsedError = JSON.parse(err);
        if (parsedError && parsedError.detail && parsedError.detail.length > 0) {
          const errorMessage = parsedError.detail;
          setIsErrorsPopupOpen(true);
          setErrorTextForPopap(errorMessage);
        } else if(parsedError && parsedError.solution && parsedError.solution.length > 0){
          const message = parsedError.solution;
          setIsErrorsPopupOpen(true);
          setErrorTextForPopap(message);
        }
      }
  })
  .finally(() => {
    setIsSolvePartOpen(true)
  })
}

  function signOut(){
    localStorage.clear();
    
    setIsLoggin(false)
    setTasks([])
    setIsErrorsPopupOpen(false)
    setErrorTextForPopap('')
    navigate('/sign-in')
  } 

  function closeAllPopups() {
    setIsErrorsPopupOpen(false)
    setErrorTextForPopap('')
  }

  return (
    <CurrentUserContext.Provider value={currentUser}> 
    <div className="App">
      <Header
        isLoggin={isLoggin}
        onSignOut={signOut}
      />

      <Routes>

        <Route
          exact path="/tasks"
          element={
            <ProtectedRoute isLoggin={isLoggin}>
              <Tasks
                tasks={tasks}
              />
            </ProtectedRoute>
        }>
      </Route>

      <Route
          exact path='/training/:_id'
          element={
            <ProtectedRoute isLoggin={isLoggin}>
              <CodeEditor
                tasks={tasks}
                sendSolve={sendSolve}
                isSolvePartOpen={isSolvePartOpen}
                tests={tests}
                isSanding={isSanding}
                isTestsCame={isTestsCame}
                taskNamber={taskNamber}
              />
            </ProtectedRoute>
        }>
      </Route>

      <Route
        path="/"
        element={
            
          <Registration
            onRegister={handleRegSubmit}
            errorMessage={errorMessage}
            error={error}
          />
            
        }>
      </Route>

      <Route
        path="/sign-in"
        element={
            
          <SignIn 
            onSubmit={handleLoginSubmit}
            error={error}
            errorMessage={errorMessage}/>
        }>
      </Route>

        <Route
          path="*"
          element={
            <NotFoundPage />
          }>
        </Route>
        
      </Routes>

      <ErrorsPopap
        isOpen={isErrorsPopupOpen}
        text={errorTextForPopap}
        onClose={closeAllPopups}
      />

      <Footer></Footer>

    </div>
    </CurrentUserContext.Provider>
  );
}

export default App;
